import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom'

import './styles.css';

import articleRedesign from '../../images/blocks/article-redesign.png';
import artsAndCulture from '../../images/blocks/arts-and-culture.png';
import remoteretro from '../../images/blocks/remoteretro.png';


class Home extends Component {
  render() {
    ReactGA.initialize('UA-68424037-1');
    return (

      <div className="grid">
        <div className="grid-item">
          <Link className="block" to="/remoteretro">
            <img src={ remoteretro } alt="Remoteretro" />
            <div className="block-hover">
              <div className="center">
                <div className="container">
                  <h4>RemoteRetro</h4>
                  <p>A tool for to have retrospective meetings with remote team members.</p>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="grid-item">
          <Link className="block" to="/article-redesign">
            <img src={ articleRedesign } alt="Article redesign" />
            <div className="block-hover">
              <div className="center">
                <div className="container">
                  <h4>The Conversation —<br />Article redesign</h4>
                  <p>Putting content up front and centre, and improving the reading experience for the mobile and desktop.</p>
                </div>
              </div>
            </div>
          </Link>
        </div>

        <div className="grid-item">
          <Link className="block" to="/arts-and-culture">
            <img src={ artsAndCulture } alt="Arts and culture" />
            <div className="block-hover">
              <div className="center">
                <div className="container">
                  <h4>The Conversation —<br />Arts + Culture section redesign</h4>
                  <p>Starting the 'magazine' style for The Conversation for the new section.</p>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>

    );
  }
}

export default Home;




// WEBPACK FOOTER //
// ./src/pages/Home/index.js